(() => {
  angular
    .module('finance')
    .controller('curlecPayoutPayoutStatusModal', CurlecPayoutPayoutStatusModal);

  CurlecPayoutPayoutStatusModal.$inject = [
    '$uibModalInstance',
    'abp.services.finance.curlecPayout',
    'moment',
  ];

  function CurlecPayoutPayoutStatusModal($uibModalInstance, curlecPayoutSvc, moment) {
    const vm = this;

    vm.loading = 0;
    vm.pageState = 0;
    vm.result = null;
    vm.parameters = {
      payoutStatus: '',
      payoutDetails: '',
      recipientReference: '',
      internalReference: '',
      customerUID: '',
    };
    vm.dateTimeParameters = {
      payoutDate: '',
      payoutFrom: '',
      payoutTo: '',
      responseFrom: '',
      responseTo: '',
    };

    vm.checkPayoutStatus = checkPayoutStatus;
    vm.back = back;
    vm.close = close;

    init();

    function init() {}

    function checkPayoutStatus() {
      let input = $.extend(
        {
          model: 'QPM',
          payoutDate: vm.dateTimeParameters.payoutDate
            ? moment(vm.dateTimeParameters.payoutDate).format('YYYY-MM-DD')
            : '',
          payoutFrom: vm.dateTimeParameters.payoutFrom
            ? moment(vm.dateTimeParameters.payoutFrom).format('YYYY-MM-DD HH:mm')
            : '',
          payoutTo: vm.dateTimeParameters.payoutTo
            ? moment(vm.dateTimeParameters.payoutTo).format('YYYY-MM-DD HH:mm')
            : '',
          responseFrom: vm.dateTimeParameters.responseFrom
            ? moment(vm.dateTimeParameters.responseFrom).format('YYYY-MM-DD HH:mm')
            : '',
          responseTo: vm.dateTimeParameters.responseTo
            ? moment(vm.dateTimeParameters.responseTo).format('YYYY-MM-DD HH:mm')
            : '',
        },
        vm.parameters
      );

      vm.pageState = 1;

      vm.loading += 1;
      curlecPayoutSvc
        .checkPayoutStatus(input)
        .success((data) => {
          vm.result = JSON.stringify(data.response, null, 2);
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function back() {
      vm.pageState = 0;
      vm.result = null;
    }

    function close() {
      $uibModalInstance.dismiss();
    }
  }
})();
